import * as React from "react";
import PropTypes from 'prop-types';

const SvgChat = props => {
  if (props.id !== "_svgchat") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M33.867 14.783c1.048 0 2.133.878 2.133 2.348v7.565c0 .55-.281 1.177-.753 1.683-.519.557-1.183.885-1.867.924l-.047.001h-1.998l-.002 3.913a.78.78 0 01-.488.72.818.818 0 01-.868-.156l-4.741-4.465c-.007-.004-.01-.008-.016-.012H20c-1.521 0-2.667-1.121-2.667-2.608V17.26c0-1.367 1.196-2.477 2.667-2.477h13.867zM24.132 7c1.25 0 2.267 1.053 2.267 2.348V13H20c-3 0-4 0-4 2v6.217h-.487l-4.837 4.359a.812.812 0 01-.864.141.785.785 0 01-.477-.717v-3.713a.347.347 0 00-.178-.071H5.71c-1.215 0-1.71-1.135-1.71-2.477V9.348C4 8.053 5.016 7 6.267 7h17.865z" fill="#202020" /></svg>;
};

SvgChat.displayName = "_svgchat";
SvgChat.propTypes = {
  id: PropTypes.string
};
SvgChat.defaultProps = {
  id: ''
};
export default SvgChat;